module.exports = __webpack_public_path__ + "static/media/online resources icon.47199a4d.svg";